module.exports = __webpack_public_path__ + "img/sticker_finished.70036cf3.png";